// Generated by scripts/build-ui-icons.mjs.
export { CaretRight as default } from "../ui/glyphs-2";
